import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateMutationRequest, CreateMutationResponse } from "../../types/Create";

/**
     * @link /api/credit-flow-backend/private/v1/funding
     */
export async function create (data: CreateMutationRequest, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CreateMutationResponse>["data"]> {
    const { data: resData } = await client<CreateMutationResponse, CreateMutationRequest>({
        method: "post",
        url: `/api/credit-flow-backend/private/v1/funding`,
        data,
        ...options
    });
    
    return resData;
};